// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"fi","zenCrossSiteLabel":"gi","vrsnlCrossSiteLabel":"hi"};